import Dict from '@/utils/dict-utils'

// 评审单发布状态
export const onlineReviewReleaseStatusDict = new Dict({
  EDITING: { label: '编辑中', value: 0, type: 'warning' },
  PUBLISHING: { label: '提交中', value: 1, type: 'primary' },
  SUCCESS: { label: '已提交', value: 2, type: 'success' },
  FAIL: { label: '提交失败', value: 3, type: 'danger' }
})

// 线上评审办法类型
export const onlineReviewTypeDict = new Dict({
  QUALIFICATION: {
    label: '资格',
    value: 1,
    onlineReviewLabel: '初步'
  },
  COMPLIANCE: {
    label: '符合性',
    value: 2,
    onlineReviewLabel: '初步'
  },
  QUOTATION: {
    label: '价格分',
    value: 3,
    onlineReviewLabel: '价格分'
  },
  TECHNICAL: {
    label: '技术',
    value: 4,
    onlineReviewLabel: '综合'
  },
  BUSINESS: { label: '商务', value: 5, onlineReviewLabel: '综合' }
})

// 线上评审方式
export const onlineReviewMethodDict = new Dict({
  PASS: { label: '通过型评审', value: 1, alias: 'pass' },
  SCORE: { label: '打分型评审', value: 2, alias: 'score' }
})

// 线上评审评审办法打分状态
export const onlineReviewScoreStatusDict = new Dict({
  PENDING: { label: '待评审', value: 0, subTitle: '未开始' },
  REVIEWING: { label: '评审中', value: 1, subTitle: '未汇总' },
  COMPLETED: { label: '已汇总', value: 2, subTitle: '已汇总' },
  RESTART: { label: '重新评审', value: 3, subTitle: '未汇总' }
})

// 线上评审投标单位打分状态
export const onlineReviewBidderScoreStatusDict = new Dict({
  PENDING: { label: '待评审', value: 0 },
  SUBMITTED: { label: '已提交', value: 1 },
  COMPLETED: { label: '已完成', value: 2 }
})

// 线上评审专家打分提交状态
export const onlineReviewExpertScoreStatusDict = new Dict({
  PENDING: { label: '待评审', value: 0 },
  REVIEWING: { label: '评审中', value: 1 },
  COMPLETED: { label: '已提交', value: 2 }
})

// 线上评审状态
export const onlineReviewStatusDict = new Dict({
  INIT: { label: '待评审', value: 0 },
  PENDING: { label: '待评审', value: 1 },
  REVIEWING: { label: '评审中', value: 2 },
  SCORED: { label: '完成打分', value: 3 },
  END: { label: '评审结束', value: 4 },
  REPORTED: { label: '评审结束', value: 5 }
})

// 询比评审办法
export const inquiryReviewTypeDict = new Dict({
  QUALIFICATION: {
    value: onlineReviewTypeDict.QUALIFICATION.value,
    label: '初步评审（符合性评审）'
  },
  BUSINESS: {
    value: onlineReviewTypeDict.BUSINESS.value,
    label: '综合评审'
  },
  QUOTATION: {
    value: onlineReviewTypeDict.QUOTATION.value,
    label: '价格分评审'
  }
})

// 招标评分方案
export const inquiryReviewScoringSchemeDict = new Dict({
  WITHOUT_HIGHEST_AND_LOWEST: { label: '去掉最高分值和最低分值', value: 2 },
  AVERAGE: { label: '取评分平均值', value: 3 }
})

// 评审报告类型
export const onlineReviewCatalogTypeDict = new Dict({
  NO_TYPE: { label: '未指定类型', value: 0 },
  RANK: { label: '综合评分排序表', value: 1 },
  WORD: { label: '评标报告', value: 2 },
  MARK: { label: '开标一览表', value: 3 },
  WAY_SUMMARY: { label: '评审办法汇总表', value: 4 },
  WAY_ITEM: { label: '评审办法明细表', value: 5 }
})

// 评标报告生成状态
export const onlineReviewCatalogStatusDict = new Dict({
  INIT: { label: '等待中', value: 0 },
  IN: { label: '生成中', value: 1 },
  SUCCESS: { label: '已完成', value: 2 },
  FAIL: { label: '生成失败，请重试', value: 3 }
})

// 评审操作方式
export const onlineReviewerModeDict = new Dict({
  PURCHASER: {
    value: 0,
    label: '项目负责人身份登记评审',
    tip: '由项目负责人一人登记评审，评审专家成员不用操作电脑'
  },
  EXPERT: {
    value: 1,
    label: '评审专家成员独立评审',
    tip: '各专家成员独自登录电脑账号独立评审'
  }
})
